/**
 * Returns true when the product carries one or more available vouchers,
 * derived from the backend's `count_voucher` aggregate.
 *
 * Used to gate the voucher list call (`useProductVoucherEligibilityList`)
 * so a product with zero vouchers triggers no network requests.
 */
export const hasCountVouchers = (
  product?: { count_voucher?: number | null } | null
): boolean => (product?.count_voucher ?? 0) > 0;
